import { render, staticRenderFns } from "./checkboxProps.vue?vue&type=template&id=0e7a124d&scoped=true&"
import script from "./checkboxProps.vue?vue&type=script&lang=js&"
export * from "./checkboxProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7a124d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCheckbox,VTextField})
